export const COVERAGE = {
  it: {
    kicker: "Dove operiamo",
    title: "Produzione video in tutta Italia",
    text: "La nostra sede è a Santarcangelo di Romagna, in provincia di Rimini, ma seguiamo produzioni in ogni regione italiana: dal capoluogo alla provincia, portiamo set, regia e post-produzione ovunque serva.",
    regionsLabel: "Tutte le regioni italiane",
    regions: [
      "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", "Friuli-Venezia Giulia",
      "Lazio", "Liguria", "Lombardia", "Marche", "Molise", "Piemonte", "Puglia", "Sardegna",
      "Sicilia", "Toscana", "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto",
    ],
    citiesLabel: "Principali città e province servite",
    cities: [
      "Rimini", "Santarcangelo di Romagna", "Riccione", "Cattolica", "Coriano", "Bellaria-Igea Marina",
      "Bologna", "Modena", "Parma", "Ravenna", "Forlì", "Cesena", "Ferrara", "Reggio Emilia", "Piacenza",
      "Ancona", "Pesaro", "Urbino", "Macerata", "Fermo", "Ascoli Piceno",
      "Firenze", "Pisa", "Livorno", "Lucca", "Siena", "Arezzo", "Grosseto", "Prato", "Pistoia",
      "Venezia", "Verona", "Padova", "Treviso", "Vicenza", "Rovigo", "Belluno",
      "Milano", "Torino", "Genova", "Trieste", "Trento", "Bolzano", "Aosta", "Perugia", "Roma",
      "L'Aquila", "Pescara", "Campobasso", "Napoli", "Salerno", "Caserta", "Bari", "Foggia", "Lecce",
      "Taranto", "Brindisi", "Potenza", "Matera", "Catanzaro", "Cosenza", "Reggio Calabria",
      "Palermo", "Catania", "Messina", "Siracusa", "Cagliari", "Sassari", "Olbia",
    ],
  },
  en: {
    kicker: "Where we operate",
    title: "Video production across Italy",
    text: "Our studio is in Santarcangelo di Romagna, in the province of Rimini, but we follow productions in every Italian region: from the capital to the smallest province, we bring set, direction and post-production wherever needed.",
    regionsLabel: "All Italian regions",
    regions: [
      "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", "Friuli-Venezia Giulia",
      "Lazio", "Liguria", "Lombardy", "Marche", "Molise", "Piedmont", "Apulia", "Sardinia",
      "Sicily", "Tuscany", "Trentino-Alto Adige", "Umbria", "Aosta Valley", "Veneto",
    ],
    citiesLabel: "Main cities and provinces served",
    cities: [
      "Rimini", "Santarcangelo di Romagna", "Riccione", "Cattolica", "Coriano", "Bellaria-Igea Marina",
      "Bologna", "Modena", "Parma", "Ravenna", "Forlì", "Cesena", "Ferrara", "Reggio Emilia", "Piacenza",
      "Ancona", "Pesaro", "Urbino", "Macerata", "Fermo", "Ascoli Piceno",
      "Florence", "Pisa", "Livorno", "Lucca", "Siena", "Arezzo", "Grosseto", "Prato", "Pistoia",
      "Venice", "Verona", "Padua", "Treviso", "Vicenza", "Rovigo", "Belluno",
      "Milan", "Turin", "Genoa", "Trieste", "Trento", "Bolzano", "Aosta", "Perugia", "Rome",
      "L'Aquila", "Pescara", "Campobasso", "Naples", "Salerno", "Caserta", "Bari", "Foggia", "Lecce",
      "Taranto", "Brindisi", "Potenza", "Matera", "Catanzaro", "Cosenza", "Reggio Calabria",
      "Palermo", "Catania", "Messina", "Syracuse", "Cagliari", "Sassari", "Olbia",
    ],
  },
};
